import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import ChangePasswordForm from '@galo-monitor/web-containers/forms/common/ChangePasswordForm'
import ConfirmationModal from '@galo-monitor/web-containers/modals/ConfirmationModal'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const ChangePasswordModal = (props) => {
  const {
    id,
    open,
    handleClose,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () =>
      createDialog({
        id: 'change-password-confirmation-modal',
        Component: ConfirmationModal,
        props: {
          title: t('are you sure you want to change your password?'),
          message: t('after processing the registration you will be redirected to login page'),
          buttonTitle: t('change password'),
          buttonProps: {
            color: 'primary'
          },
          onConfirm: () => formRef.current.submit()
        }
      }),
    [createDialog, t]
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    ({ response }, closeModal) => {
      setLoading(false)

      createDialog({
        id: 'error-change-password',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'female',
            action: toLower(t('update')),
            this: toLower(t('password'))
          })  }.`,
          message: t(response?.data?.errors?.[0]?.message)
        }
      })

      if (closeModal)
        handleClose()
    },
    [createDialog, handleClose, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('new password register') }
      maxWidth="xs"
      fullWidth
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <ChangePasswordForm
        ref={ formRef }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

ChangePasswordModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired
}

export default ChangePasswordModal
